import type { OfficeApp } from './store/schema/OfficeApp';
import type { IOverflowSetItemProps } from '@fluentui/react/lib/OverflowSet';
import * as trace from 'owa-trace';
import { Module } from 'owa-workloads';
import isSupportedOfficeRailApp from './isSupportedOfficeRailApp';
import onOfficeAppClick from './actions/onOfficeAppClick';
import getSelectedOfficeRailApp from './selectors/getSelectedOfficeRailApp';
import getAppHostAppPath from './getAppHostAppPath';
import { default as OrganizationRegular } from 'owa-fluent-icons-svg/lib/icons/OrganizationRegular';
import { default as AppFolderRegular } from 'owa-fluent-icons-svg/lib/icons/AppFolderRegular';
import { communities } from './utils/LeftRailApp.locstring.json';
import loc from 'owa-localize';

import EXCEL_SVG from './resources/Excel_16x.svg';
import POWERPOINT_SVG from './resources/PowerPoint_16x.svg';
import WORD_SVG from './resources/Word_16x.svg';
import ONENOTE_SVG from './resources/OneNote_16x.svg';
import YAMMER_SVG from './resources/yammer_16x.svg';
import BOOKINGS_SVG from './resources/bookings_16x.svg';
import isMOSLaunchPagesEnabled from './utils/isMOSLaunchPagesEnabled';
import getOfficeAppData from './selectors/getOfficeAppData';

export default function getOfficeAppItemDisplayProperties(
    app: OfficeApp,
    currentlySelectedModule: Module
): IOverflowSetItemProps {
    const appData = getOfficeAppData(app);
    let svgPath;
    let iconName;
    let iconProps;
    let displayText = appData.displayText;

    switch (app) {
        case 'f3a6e67f-850d-4dd9-960a-04c6638ded36':
            iconName = AppFolderRegular;
            break;
        case '9b049ed6-fc8b-40c7-815b-bf84e344d270':
            iconName = OrganizationRegular;
            break;
        case 'Word':
            svgPath = WORD_SVG;
            break;
        case 'Excel':
            svgPath = EXCEL_SVG;
            break;
        case 'Powerpoint':
            svgPath = POWERPOINT_SVG;
            break;
        case 'OneNote':
            svgPath = ONENOTE_SVG;
            break;
        case 'db5e5970-212f-477f-a3fc-2227dc7782bf':
            svgPath = YAMMER_SVG;
            if (isMOSLaunchPagesEnabled()) {
                displayText = loc(communities);
            }
            break;
        case '4c4ec2e8-4a2c-4bce-8d8f-00fc664a4e5b':
            svgPath = BOOKINGS_SVG;
            break;
        default:
            trace.errorThatWillCauseAlert('Svg does not exist for app ' + appData.displayText);
            svgPath = '';
            break;
    }

    const url = isSupportedOfficeRailApp(app) ? getAppHostAppPath(app) : appData.url;
    iconProps = iconName
        ? { iconName: iconName }
        : {
              imageProps: {
                  src: svgPath,
                  width: 16,
                  height: 16,
                  shouldFadeIn: false,
              },
          };

    return {
        key: app,
        workload: app,
        text: displayText,
        ariaLabel: appData.title,
        app: app,
        url: url,
        iconProps: iconProps,
        onClick: () => {
            onOfficeAppClick(app, currentlySelectedModule);
        },
        isSelected:
            getSelectedOfficeRailApp() === app && currentlySelectedModule === Module.AppHost,
        renderAsButton: isSupportedOfficeRailApp(app),
        openInNewTab: true,
    };
}
